import { AfterViewInit, Directive, ElementRef, Renderer2, inject } from '@angular/core';

@Directive({
  selector: '[ninetyChatWindowHeight]',
  standalone: true,
})
export class ChatWindowHeightDirective implements AfterViewInit {
  private renderer = inject(Renderer2);
  private elementRef = inject(ElementRef);

  private el: HTMLElement;

  constructor() {
    this.el = this.elementRef.nativeElement as HTMLElement;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.setHeight();
      // wait until after animation runs.
    }, 300);
  }

  private setHeight() {
    const wrapper = document.getElementById('conversation-window');
    const height = wrapper?.clientHeight;
    this.renderer.setStyle(this.el, 'height', `${height}px`);
    //const conversation = document.getElementById('maz-conversation');
    // conversation.scrollTop = conversation.scrollHeight;
    this.el.scrollTop = this.el.scrollHeight;
  }
}
